import { useState } from "react";
import { useTheme } from "../../../../../../../hooks/WebCheckinUsers/theme";
import { Guest, IReservation } from "../../../../interfaces";
import { SendSteps } from "./sendSteps";
import { CgArrowLeft } from "react-icons/cg";
import { inactiveItens } from "../../../../../../../theme";
import { ArrowRightIcon } from "../../../../../../../components/SvgComponents/Icons/ArrowRightIcon";
import ButtonWebCheckinUser from "../../../../../../../components/ButtonWebCheckinUser/index";
import { GuestCheck } from "../../../../../../../components/SvgComponents/Icons/GuestCheck";
import { StepReservationSteps, useGlobalWebCheckinUser } from "../../../../../../../hooks/WebCheckinUsers/global";

interface IDocumentStepProps {
  reservation: IReservation;
  onNext: () => void;
  goBack: () => void;
  guests: Guest[];
  setGuests: React.Dispatch<React.SetStateAction<Guest[]>>;
}

export const DocumentStep: React.FC<IDocumentStepProps> = ({
  goBack,
  guests,
  onNext,
  reservation,
  setGuests,
}) => {
  const { colorsTheme } = useTheme();
  const { contractModel, getSetReservationStep } = useGlobalWebCheckinUser();

  const [selectedGuest, setSelectedGuest] = useState<Guest | null>(null);
  const [selectedGuestIndex, setSelectedGuestIndex] = useState(-1);
  if (selectedGuest?.name)
    return (
      <SendSteps
        defaultGuest={selectedGuest}
        isPrimaryGuest={selectedGuest?.primary === true || selectedGuestIndex === 0}
        onCancel={() => setSelectedGuest(null)}
        onNext={(guest) => {
          setGuests((prevGuests) => {
            return prevGuests.map((prevGuest) => {
              if (
                prevGuest.name === guest.name &&
                prevGuest.email === guest.email &&
                prevGuest.phone === guest.phone &&
                prevGuest.cpf === guest.cpf/*  &&
                prevGuest.compare_score === guest?.compare_score &&
                prevGuest.compare_valid === guest?.compare_valid  */
              ) {
                return guest;
              }
              return prevGuest;
            });
          });
          setSelectedGuest(null);
        }}
      />
    );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "0 20px",
        flex: 1,
      }}
    >
      <div
        style={{ display: "flex", flexDirection: "column", gap: 10, flex: 1 }}
      >
        <div
          style={{
            display: "flex",
            gap: 10,
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 10,
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              fontSize: 18,
              flexDirection: "row",
              display: "flex",
              alignItems: "center",
              gap: 5,
              position: "relative",
              justifyContent: "center",
              flex: 1,
            }}
          >
            <div
              style={{ position: "absolute", left: 0 }}
              className="pointer"
              onClick={() => goBack()}
            >
              <CgArrowLeft color={inactiveItens.light} size={20} />
            </div>
            <div>Enviar documentos</div>
            <div
              style={{ position: "absolute", right: 0 }}
              className="pointer"
              onClick={() => goBack()}
            >
              <div style={{ color: "#8D8D8D", fontSize: 12 }}>{getSetReservationStep(StepReservationSteps.Documents)}</div>
            </div>
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ fontSize: 14, color: "#5B5B5B" }}>
            Escolha o hóspede e envie os documentos necessários para o check-in.
          </div>
        </div>
        {guests.map((guest, index) => (
          <>
            <div style={{ borderTop: "1px solid #EFEFEF", marginTop: 10 }} />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                gap: 10,
                marginTop: 10,
                alignItems: "center",
                cursor: !guest?.match ? "pointer" : "default",
              }}
              onClick={() => {
                if (!guest?.match) {
                  setSelectedGuest(guest);
                  setSelectedGuestIndex(index);
                }
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                {index === 0 && (
                  <div
                    style={{
                      color: "#5B5B5B",
                      fontSize: 14,
                    }}
                  >
                    Titular da Reserva
                  </div>
                )}
                {index !== 0 && (
                  <div
                    style={{
                      color: "#5B5B5B",
                      fontSize: 12,
                    }}
                  >
                    {index}º Acompanhante
                  </div>
                )}
                <div style={{ fontSize: 18, fontWeight: "bold" }}>
                  {guest.name}
                </div>
              </div>
              {guest?.match && <GuestCheck />}
              {!guest?.match && <ArrowRightIcon />}
            </div>
          </>
        ))}
      </div>
      <ButtonWebCheckinUser
        background={colorsTheme.secondary.light}
        color={"#292929"}
        style={{ marginTop: 30 }}
        onClick={onNext}
        disabled={guests.some((guest) => !guest?.match)}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flex: 1,
            padding: "0px 10px",
          }}
        >
          {contractModel?.id ? "Revisar contrato" : "Realizar web check-in"}
          <ArrowRightIcon />
        </div>
      </ButtonWebCheckinUser>
    </div>
  );
};
